<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (click)="Save()"></app-form-save-button>
    </app-pageheader>
    <app-validationsummary [Form]="Form"></app-validationsummary>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Permit Type Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name" tippy="The name that users will see when buying permits">
              <p class="control mb-2">
                <input formControlName="Name" class="input" type="text" />
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </p>
            </app-field>
            <app-field Label="External ID" tippy="External identifier used by integrations such as Decathlon to map incoming permit groups directly to this permit type.">
              <p class="control mb-2">
                <input formControlName="ExternalId" class="input" type="text" />
                <app-validator [For]="this.Form.get('ExternalId')"></app-validator>
              </p>
            </app-field>
            <app-field Label="Active Period" [HasAddons]="true" tippy="Defines the active period that the permit can be used.">
              <div class="control is-expanded mb-2">
                <input formControlName="ActiveStartDateLocal" class="input" type="date"  required>
                <app-validator [For]="this.Form.get('ActiveStartDateLocal')"></app-validator>
              </div>
              <div class="control">
                <button class="button is-static"> to </button>
              </div>
              <div class="control is-expanded mb-2">
                <input formControlName="ActiveEndDateLocal" class="input" type="date" required>
                <app-validator [For]="this.Form.get('ActiveEndDateLocal')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Purchase Period" tippy="The period in which users may buy permit of this type. If the purchase period starts prior to the Active Period then permits will be on pre-sale and only usable during the Active Period." [HasAddons]="true" tippy="">
              <div class="control is-expanded mb-2">
                <input formControlName="PurchaseStartDateLocal" class="input" type="date">
                <app-validator [For]="this.Form.get('PurchaseStartDateLocal')"></app-validator>
              </div>
              <div class="control">
                <button class="button is-static"> to </button>
              </div>
              <div class="control is-expanded mb-2">
                <input formControlName="PurchaseEndDateLocal" class="input" type="date">
                <app-validator [For]="this.Form.get('PurchaseEndDateLocal')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Allocation Mode" [HasAddons]="false" tippy="Governs how users will obtain permits. 'User Can Purchase' means users can buy in permit or portal, 'System Administrator Must Grant' means users cannot buy this permit, it must be assigned through this administration panel.">
              <div class="control is-expanded mb-2">
                <div class="select is-fullwidth">
                  <select formControlName="PurchasingOption" class="input is-fullwidth">
                    <option value="0">User can Purchase Permit</option>
                    <option value="1">System Administrator must Grant Permit</option>
                    <option value="2">Direct Purchase via Link</option>
                  </select>                        
                </div>
              </div>
            </app-field>
            <app-field Label="Maximum Active Permits" tippy="The maximum number of permits available to users, or unlimited if no limit is specified. Once a permit is cancelled it no longer counts towards this limit.">
              <p class="control is-expanded mb-2">
                <input formControlName="MaxActivePermits" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                <app-validator [For]="this.Form.get('MaxActivePermits')"></app-validator>
              </p>
            </app-field>
            <app-field Label="Limit Usage" [HasAddons]="true" tippy="If specified, this restricts how many times each permit may be used over a given time period.">
              <p class="control is-expanded mb-2">
                <input formControlName="MaxUsesPerPeriod" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                <app-validator [For]="this.Form.get('MaxUsesPerPeriod')"></app-validator>
              </p>
              <p class="control is-expanded select mb-2">
                <select formControlName="MaxUsePeriod" class="input is-fullwidth">
                  <option value="101">Total</option>
                  <option value="0">Daily</option>
                  <option value="1">Weekly</option>
                  <option value="3">Monthly</option>
                  <option value="4">Yearly</option>
                </select>
              </p>
            </app-field>
            <app-field Label="Assigned Parking Spaces" tippy="If enabled, each permit will be allocated a specific parking space and the permit may only be used for that parking space.">
              <div class="control">
                <app-toggleswitch formControlName="LimitToParkingSpace"></app-toggleswitch>
              </div>
            </app-field>
            <app-field Label="Require Registered Vehicles" tippy="If enabled, requires users to enter vehicle License Plate details when buying a permit so that permitted vehicles may be identified by plate.">
              <div class="control is-expanded mb-2">
                <app-toggleswitch formControlName="RequireRegisteredVehicles"></app-toggleswitch>
              </div>
            </app-field>
            @if (CustomerGroupsAvailable) {
              <app-field Label="Customer Group" tippy="Customer group for sessions using permits of this type">
                <div class="control is-expanded mb-2">
                  @if (CustomerGroups != null) {
                    <div class="select is-fullwidth">
                      <select formControlName="CustomerGroupId" class="input is-fullwidth">
                        <option [ngValue]="null">None</option>
                        @for (cg of CustomerGroups; track cg) {
                          <option [ngValue]="cg.Id">{{cg.Name}}</option>
                        }
                      </select>
                    </div>
                  }
                  @if (CustomerGroups == null) {
                    <span>
                      Loading...
                    </span>
                  }
                </div>
              </app-field>
            }
            @if (this.Form.get('RequireRegisteredVehicles')?.value) {
              <app-field Label="Max Vehicles" [HasAddons]="true" tippy="The maximum number of vehicles that can be added to a permit. The cooldown prevents users from changing vehicle details regularly to circumvent the vehicle limit.">
                <p class="control is-expanded mb-2">
                  <input formControlName="MaxVehicles" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                  <app-validator [For]="this.Form.get('MaxVehicles')"></app-validator>
                </p>
                <div class="control">
                  <button class="button is-static"> vehicles max, with a cooldown period of </button>
                </div>
                <p class="control is-expanded mb-2">
                  <input formControlName="VehicleModificationTimeout" class="input" type="number" min="0" max="10000" placeholder="No Limit"  />
                  <app-validator [For]="this.Form.get('VehicleModificationTimeout')"></app-validator>
                </p>
                <p class="control">
                  <button class="button is-static"> hrs </button>
                </p>
              </app-field>
            }
            <app-field Label="Mode" tippy="'Single User' means the permit is for one user only. 'Multi User' allows multiple users on a permit.">
              <div class="control is-expanded mb-2">
                <div class="select is-fullwidth">
                  <select class="input is-fullwidth" formControlName="IsMultiUser">
                    <option [ngValue]="false">Single User</option>
                    <option [ngValue]="true">Multi User</option>
                  </select>
                </div>
              </div>
            </app-field>
            @if (this.Form.get('IsMultiUser')?.value) {
              <div>
                <app-field Label="User Limits" [HasAddons]="true" tippy="The minimum and maximum amount of users allowed on permits of this type. A permit will not activate until the minimum threshold has been reached. Each permit must maintain the minimum number of users to stay active.">
                  <div class="control is-expanded">
                    <input formControlName="MinUsers" class="input" type="number" min="2" max="1000000" placeholder="Required" required  />
                    <app-validator [For]="this.Form.get('MinUsers')"></app-validator>
                  </div>
                  <div class="control">
                    <button class="button is-static"> to </button>
                  </div>
                  <div class="control is-expanded">
                    <input formControlName="MaxUsers" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                    <app-validator [For]="this.Form.get('MaxUsers')"></app-validator>
                  </div>
                </app-field>
                <app-field Label="Require Confirmations" tippy="If enabled, requires other users in the permit to confirm each time a permit is used. Can be used to ensure carpool style permits are being used appropriately.">
                  <div class="control is-expanded mb-2">
                    <app-toggleswitch formControlName="RequireConfirmations"></app-toggleswitch>
                  </div>
                </app-field>
                @if (this.Form.get('RequireConfirmations')?.value) {
                  <app-field Label="Confirmation Distance" [HasAddons]="true" tippy="Can be used to ensure that confirming users on a permit are present and not falsely confirming from another location.">
                    <div class="control">
                      <button class="button is-static"> Users must confirm within </button>
                    </div>
                    <div class="control is-expanded">
                      <input formControlName="MaxConfirmationDistance" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                      <app-validator [For]="this.Form.get('MaxConfirmationDistance')"></app-validator>
                    </div>
                    <div class="control">
                      <button class="button is-static"> {{orgService.KMorMiles()}} </button>
                    </div>
                  </app-field>
                }
                @if (this.Form.get('RequireConfirmations')?.value) {
                  <app-field Label="Suspension" [HasAddons]="true" tippy="If enabled, will automatically suspend permits that fail to receive the required number of confirmations.">
                    <div class="control">
                      <button class="button is-static"> After </button>
                    </div>
                    <p class="control is-expanded mb-2">
                      <input formControlName="MaxNonConfirmingUsers" class="input" type="number" min="0" max="1000000" placeholder="No Limit"  />
                      <app-validator [For]="this.Form.get('MaxNonConfirmingUsers')"></app-validator>
                    </p>
                    <p class="control">
                      <!--Get this value from Organization Settings-->
                      <button class="button is-static"> users fail to confirm on</button>
                    </p>
                    <p class="control is-expanded mb-2">
                      <input formControlName="MaxConfirmationFails" class="input" type="number" min="0" max="365" placeholder="No Limit"  />
                      <app-validator [For]="this.Form.get('MaxConfirmationFails')"></app-validator>
                    </p>
                    <div class="control">
                      <button class="button is-static"> occasions </button>
                    </div>
                  </app-field>
                }
              </div>
            }
          </div>
        </article>
        <article class="panel">
          <div class="panel-heading">Wait List Settings</div>
          <div class="panel-block" style="display:block;" >
            <app-field Label="Wait list" tippy="If enabled, the permit will still show in the list of available permits even after the Maximum Active Permits limit is reached, and allow users to join a waitlist for when a permit becomes available.">
              <div class="control">
                <app-toggleswitch formControlName="EnableWaitlist"></app-toggleswitch>
              </div>
            </app-field>
            @if (this.Form.get('EnableWaitlist')?.value) {
              <div>
                <app-field Label="Invite Timeout" [HasAddons]="true" tippy="The number of hours a users has to buy the allocated permit after it becomes available. After this time the user will be skipped and another user offered the permit.">
                  <div class="control is-expanded mb-2">
                    <input formControlName="WaitlistInviteTimeout" class="input" type="number" min="0" max="10000" placeholder="No Limit"  />
                    <app-validator [For]="this.Form.get('WaitlistInviteTimeout')"></app-validator>
                  </div>
                  <div class="control">
                    <button class="button is-static"> hours </button>
                  </div>
                </app-field>
                <app-field Label="Timeout Action" tippy="Sets the action if a user fails to buy the allocated permit before the timeout period elapses.">
                  <div class="control is-expanded mb-2">
                    <div class="select is-fullwidth">
                      <select formControlName="WaitlistTimeoutAction" class="input is-fullwidth" (change)="checkTimeoutAction($event)">
                        <option value="0">Leave User at Front</option>
                        <option value="1">Send User to Back</option>
                        <option value="2">Remove User from Queue</option>
                      </select>
                    </div>
                  </div>
                </app-field>
                @if (this.Form.get('WaitlistTimeoutAction')?.value != 2) {
                  <app-field Label="Invite retries" [HasAddons]="true" tippy="The number unsuccessful attempts to allocate a permit to a waitlist user before the user is removed from the waitlist.">
                    <div class="control">
                      <button class="button is-static"> Remove users from queue after </button>
                    </div>
                    <div class="control is-expanded mb-2">
                      <input formControlName="MaxWaitlistInviteAttempts" class="input" type="number" min="0" max="100" placeholder="No Limit"  />
                      <app-validator [For]="this.Form.get('MaxWaitlistInviteAttempts')"></app-validator>
                    </div>
                    <div class="control">
                      <button class="button is-static"> invitations </button>
                    </div>
                  </app-field>
                }
                <app-field Label="Default Waitlist State" tippy="Optional label to show as the default state for waitlist entries.">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select formControlName="WaitlistDefaultState" class="input is-fullwidth">
                        @for (state of WaitlistWorkflowStates; track state) {
                          <option [ngValue]="state.StateKey">{{state.Name}}</option>
                        }
                      </select>
                    </div>
                    <app-validator [For]="Form.get('WaitlistDefaultState')"></app-validator>
                  </div>
                </app-field>
              </div>
            }
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <div class="panel-heading">Permit Restrictions</div>
          <div class="panel-block" style="display:block;" >
            <app-field Label="Restrict To User Roles" [HasAddons]="this.Form.get('RestrictToUserRoles')?.value" tippy="Restricts a permit to only users with certain roles. For multi-user and shared permits all users must have the role to join.">
              <div class="control">
                <div class="field is-grouped is-grouped-multiline">
                  <app-toggleswitch formControlName="RestrictToUserRoles"></app-toggleswitch>
                  @if (this.Form.get('RestrictToUserRoles')?.value) {
                    <app-selectortaglist [FollowsCheckbox]="true" formArrayName="RoleRestrictions" ModelType="Role Restriction" [IsMultiSelect]="true" AddItemApi="organization/roles/search/enduser" itemsDisplayProperty="RoleName" [MapProperties]="[['RoleId', 'Id'], ['RoleName', 'Name']]">
                    </app-selectortaglist>
                  }
                </div>
              </div>
            </app-field>
            <app-field Label="Limit To Parking Space Types" [HasAddons]="this.Form.get('RestrictBySpaceType')?.value" tippy="Restricts use of permits to only the specified types of parking space. If no types are specified then permits may be applied to spaces of any type.">
              <div class="control">
                <div class="field is-grouped is-grouped-multiline">
                  <app-toggleswitch formControlName="RestrictBySpaceType"></app-toggleswitch>
                  @if (this.Form.get('RestrictBySpaceType')?.value) {
                    <app-selectortaglist [FollowsCheckbox]="true" formArrayName="SpaceTypeRestrictions" ModelType="Parking Space Type" [IsMultiSelect]="true" AddItemApi="infrastructure/spacetypes/searches" itemsDisplayProperty="ParkingSpaceTypeName" [MapProperties]="[['ParkingSpaceTypeId', 'Id'], ['ParkingSpaceTypeName', 'Name']]">
                    </app-selectortaglist>
                  }
                </div>
              </div>
            </app-field>
            <app-field Label="Limited To Parking Structures" [HasAddons]="true" tippy="Restricts use of permits to only spaces within the specified structures. If no structures are specified then permits may be applied to any space, subject to other restrictions.">
              <div class="control">
                <div class="field is-grouped is-grouped-multiline">
                  @for (x of this.Form.get('ParkingStructures')?.value; track x; let i = $index) {
                    <div class="tags has-addons">
                      <a class="tag">{{x.LocationString}}</a>
                    </div>
                  }
                  <div class="tags has-addons">
                    <a class="tag button is-primary" (click)="AddParkingStructureRestriction()">Edit</a>
                  </div>
                </div>
              </div>
            </app-field>
            <app-field Label="Permit Exclusions" [HasAddons]="true" tippy="A user cannot hold this permit type if they hold any permit of an excluded types. Exclusions apply both ways so any excluded type will also have an exclusion against this permit type. ">
              <div class="control">
                <app-selectortaglist formArrayName="MutualExclusions" ModelType="Permit Type" [IsMultiSelect]="true" AddItemApi="permits/standardpermittypes/searches" itemsDisplayProperty="ParkingPermitTypeName" [MapProperties]="[['ParkingPermitTypeId','Id'], ['ParkingPermitTypeName','Name']]">
                </app-selectortaglist>
              </div>
            </app-field>
            <app-field Label="Restrict Times of Day" tippy="Restricts the times of day that permits may be used. If a user attempts to use a permit outside these times they will receive an error.">
              <div class="control">
                <app-toggleswitch formControlName="RestrictTimesOfDay" (change)="TimesOfDay($event)"></app-toggleswitch>
              </div>
            </app-field>
            @if (this.Form.get('RestrictTimesOfDay')?.value) {
              <app-field Label="Time Restrictions" formArrayName="TimeRestrictions" [HasAddons]="true">
                <div class="control">
                  <span>
                    @for (price of FormArray(this.Form, 'TimeRestrictions').controls; track price; let i = $index) {
                      <div>
                        <div [formGroupName]="i" >
                          <div style="display: flex;">
                            <div class="control select has-addons">
                              <select formControlName="DayOfWeek" class="input">
                                <option value="0">Sunday</option>
                                <option value="1">Monday</option>
                                <option value="2">Tuesday</option>
                                <option value="3">Wednesday</option>
                                <option value="4">Thursday</option>
                                <option value="5">Friday</option>
                                <option value="6">Saturday</option>
                              </select>
                            </div>
                            <div class="control is-expanded has-addons">
                              <input type="time" class="input time" formControlName="StartTimeLocal">
                            </div>
                            <div class="control has-addons">
                              <button class="button is-static"> &#x2192; </button>
                            </div>
                            <div class="control is-expanded has-addons">
                              <input type="time" class="input time" formControlName="EndTimeLocal">
                            </div>
                            <div class="control has-addons">
                              <button class="button is-light ng-star-inserted" (click)="RemoveTimeRestriction(i)"><i class="fa fa-trash"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </span>
                  <add-button Class="is-small" (AddObject)="AddTimeRestriction()"></add-button>
                </div>
              </app-field>
            }
          </div>
        </article>
        <article class="panel">
          <div class="panel-heading">Pricing</div>
          <div class="panel-block" style="display:block;" >
            <app-field Label="Payment Schedule" [HasAddons]="true" tippy="The defined schedule for when to charge a user for this permit.">
              <app-recurring-schedule [enableDateShifting]="false" [allowTimeOfDay]="false" scheduleName="Payment Schedule" formControlName="PaymentSchedule"></app-recurring-schedule>
            </app-field>
            <app-field Label="Prices" formArrayName="Prices" tippy="The price of the permit. For One-Off Payments, this is the total payable. For recurring payments this is the price per period." [HasAddons]="true">
              <div class="control">
                <span>
                  @for (price of FormArray(this.Form, 'Prices').controls; track price; let i = $index) {
                    <div>
                      <div [formGroupName]="i" >
                        <div style="display: flex;">
                          <div class="control is-expanded has-addons mb-2">
                            <app-currency-input formControlName="Price">
                            </app-currency-input>
                          </div>
                          <div class="control is-expanded has-addons">
                            <button class="button is-static"> from </button>
                          </div>
                          <div class="control is-expanded has-addons mb-2">
                            <input formControlName="EffectiveStartDateLocal" class="input" type="date">
                          </div>
                          <div class="control has-addons">
                            <button class="button is-light ng-star-inserted" [disabled]="price.get('NotificationSent')?.value" (click)="RemovePrice(i)"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </span>
                <add-button Class="is-small" (AddObject)="AddPrice()"></add-button>
              </div>
            </app-field>
            @if (isPaymentScheduleRecurring()) {
              <app-field Label="Pro-Rata Price" tippy="If enabled, first payment will be pro-rated to the remainder of the initial period.">
                <div class="control is-expanded mb-2">
                  <app-toggleswitch formControlName="ProRataPrice"></app-toggleswitch>
                </div>
              </app-field>
            }
            @if (this.Form.get('IsMultiUser')?.value) {
              <app-field Label="Multi-User Payment Mode" tippy="Determines how payment is split across multiple users on a permit.">
                <div class="control is-expanded mb-2">
                  <div class="select is-fullwidth">
                    <select class="input is-fullwidth" formControlName="MultiUserPaymentOption">
                      <option [ngValue]="2">Charge Per User</option>
                      <option [ngValue]="0">Sole Payer</option>
                    </select>
                  </div>
                </div>
              </app-field>
            }
            @if (isPaymentScheduleRecurring()) {
              <app-field Label="Automatic Removal" [HasAddons]="true" tippy="If specified, permits will be cancelled after the specified number of days of non-payment. For Multi-User permits only the non-paying user will be removed, unless they are the last remaining user in which case the permit will also be cancelled.">
                <div class="control">
                  <button class="button is-static"> {{(this.Form.get('MultiUser')?.value ? 'Remove users after' : 'Cancel Permit after')}}</button>
                </div>
                <div class="control is-expanded mb-2">
                  <input formControlName="DaysUntilCancellation" class="input" type="number" min="0" placeholder="No Limit"  />
                  <app-validator [For]="this.Form.get('DaysUntilCancellation')"></app-validator>
                </div>
                <div class="control">
                  <button class="button is-static"> {{((this.Form.get('DaysUntilCancellation')?.value == 1) ? 'day' : 'days')}} of non-payment </button>
                </div>
              </app-field>
            }
            @if (isPaymentScheduleRecurring()) {
              <app-field Label="Renewal Offset Days" tippy="Days offset for the start of a renewed permit.">
                <p class="control is-expanded mb-2">
                  <input formControlName="RenewalOffsetDays" class="input" type="number" min="0" max="365" placeholder="None" />
                </p>
              </app-field>
            }
            <app-field Label="Price Change Alert (days)" tippy="Days in advance to alert of upcoming price change.">
              <p class="control is-expanded mb-2">
                <input formControlName="DaysUntilPriceChangeAlert" class="input" type="number" min="0" max="365" placeholder="None" />
              </p>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}